<template>
  <Header />
  <Contents :id="$route.params.id" />
  <Footer />
</template>

<script>
import Header from "@/components/HeaderSub.vue";
import Contents from "@/components/ColumnDetail.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "ColumnDetail",
  components: { Header, Contents, Footer },
  mounted() {
    const title = "コラム記事 | MOG(モグー) ボートレース蒲郡";
    const description =
      "GAMA専門家によるモーター分析やレース考察などのコラム記事です。";
    document.title = title;
    document
      .querySelector("meta[property='og:title']")
      .setAttribute("content", title);
    document
      .querySelector("meta[name='description']")
      .setAttribute("content", description);
    document
      .querySelector("meta[property='og:description']")
      .setAttribute("content", description);
  },
};
</script>
